//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import calendarDateNav from '../../../../../components/datePicker/calendar/calendarDateNav';

import x16icarrowleft from '../../../../../iconsPublicSite/icons/x16icarrowleft/x16icarrowleft';
import x16icarrowright from '../../../../../iconsPublicSite/icons/x16icarrowright/x16icarrowright';

dayjs.extend(localeData);

export default {
  components: {
    x16icarrowleft,
    x16icarrowright,
  },
  extends: calendarDateNav,
};
